import { PropsWithChildren } from 'react'

import styles from './Chip.module.scss'

export type ChipColor = 'blue' | 'green' | 'neutral' | 'purple' | 'red' | 'white' | 'yellow'

interface ChipProps extends PropsWithChildren {
  color?: ChipColor
}

const Chip = ({ children, color = 'yellow' }: ChipProps) => (
  <span className={styles.chip} data-color={color}>
    {children}
  </span>
)

export default Chip
